import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { useNotifyStatus } from "contexts/status";
import { fetchErrorDetail } from "helpers";
import { useTenantTranslation } from "hooks/formatters";
import { ReactNode } from "react";

interface SensorEditorDialogProps {
  title: string;
  busy: boolean;
  valid: boolean;
  onClose: () => void;
  onSave: () => Promise<void>;
  errorMessage: string;
  children: ReactNode;
}

export const SensorEditorDialog = ({
  title,
  busy,
  valid,
  onClose,
  onSave,
  errorMessage,
  children,
}: SensorEditorDialogProps) => {
  const { t } = useTenantTranslation();
  const notifyStatus = useNotifyStatus();
  const save = async () => {
    try {
      await onSave();
      notifyStatus({ type: "success", text: t("changesSaved") });
      onClose();
    } catch (error) {
      notifyStatus({
        type: "error",
        text: fetchErrorDetail(error) ?? errorMessage,
      });
    }
  };
  return (
    <Dialog open onClose={busy ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 2 }}>
          {children}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={busy}>
          {t("cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={() => void save()}
          disabled={busy || !valid}
        >
          {t("save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
